export enum Type {
  AJAX_REVERSE_MORTGAGE_CALCS         = 'AJAX_REVERSE_MORTGAGE_CALCS',
  AJAX_REVERSE_MORTGAGE_CALCS_SUCCESS = 'AJAX_REVERSE_MORTGAGE_CALCS_SUCCESS',
  AJAX_REVERSE_MORTGAGE_CALCS_FAIL    = 'AJAX_REVERSE_MORTGAGE_CALCS_FAIL',
  AJAX_EMAIL_REVERSE_SUMMARY          = 'AJAX_EMAIL_REVERSE_SUMMARY',
  AJAX_EMAIL_REVERSE_SUMMARY_SUCCESS  = 'AJAX_EMAIL_REVERSE_SUMMARY_SUCCESS',
  AJAX_EMAIL_REVERSE_SUMMARY_FAIL     = 'AJAX_EMAIL_REVERSE_SUMMARY_FAIL',
}
